import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CrudAttributeTypeService} from '../../../../../shared/services/crud-attribute-type.service';
import {HttpClient} from '@angular/common/http';

import {concatMap} from 'rxjs/operators';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';


@Component({
  selector: 'app-attribute-type-list',
  templateUrl: './attribute-type-list.component.html',
  styleUrls: ['./attribute-type-list.component.scss']
})
export class AttributeTypeListComponent implements OnInit {


  confirmDialog: BsModalRef;
  dialogEntityid = '';
  entityroot = '';

  displayedColumns: any = [];
  keyColumns: any = []; // Columns with link
  datalistsource: MatTableDataSource<any>; // MatTableDataSource
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;


  attributgroupe: any;
  serverRoot = 'http://api-dev.localhost';

  constructor(
    protected httpcrud: CrudAttributeTypeService, // Specific
    protected modalservice: BsModalService,
    private http: HttpClient
  ) {
  }

  ngOnInit() {
    this.initSpecificListConfig();
    this.initList();
  }

  initSpecificListConfig() {
    const pathURL = window.location.pathname;
    const pathURLsplitted = pathURL.split('/');

    for (const entry of pathURLsplitted) {
      if (Number(entry)) {
        const query = this.httpcrud.getEntities(entry)
          .subscribe(result => {
            this.attributgroupe = result.results;
          }); // subscribe
      } // if
    } // for

    this.displayedColumns = ['attribute', 'defaultValue', 'delete'];
    this.keyColumns = ['attribute'];
    // Entities API url
    this.entityroot = '/attributes-type';
  } // initSpecificListConfig


  confirmSubEntityDeletion() {

    const pathURL = window.location.pathname;
    const pathURLsplitted = pathURL.split('/');

    for (const AttrGroupID of pathURLsplitted) {
      if (Number(AttrGroupID)) {
        const query = this.httpcrud.removeEntity(this.dialogEntityid).pipe(
          concatMap(() => this.httpcrud.getEntities(AttrGroupID))
        );
        query.subscribe((allresults) => {
          this.attributgroupe = new MatTableDataSource(allresults.results);
          this.attributgroupe.sort = this.sort;
          this.closeConfirmRemoveDialog();
        });
      } // if
    } // for
  } // confirmSubEntityDeletion


  getCreatSubLink() {
    const pathURL = window.location.pathname;
    return [pathURL + '/create'];
  }

  getEditSubLink(elementElement: any) {
    const pathURL = window.location.pathname;
    return [pathURL + '/' + elementElement + '/edit'];
  }


  getCrud() {
    return this.httpcrud;
  }

  onDataSourceReady() {

  } // initListFilters

  initList() {
    const query = this.httpcrud.getEntities();
    query.subscribe((allresults) => {
      this.datalistsource = new MatTableDataSource(allresults.results);
      this.datalistsource.sort = this.sort;
      this.datalistsource.paginator = this.paginator;
      this.onDataSourceReady();
    });
  } // initList

  isKeyColumn(columnname: string) {
    return this.keyColumns.indexOf(columnname) !== -1;
  } // isKeyColumn

  closeConfirmRemoveDialog() {
    this.dialogEntityid = '';
    this.confirmDialog.hide();
  }

  confirmRemoveDialog(template: TemplateRef<any>, entityid: string = '') {
    this.dialogEntityid = entityid;
    this.confirmDialog = this.modalservice.show(template);
  }

  confirmEntityDeletion() {
    const query = this.httpcrud.removeEntity(this.dialogEntityid).pipe(
      concatMap(() => this.httpcrud.getEntities())
    );

    query.subscribe((allresults) => {

      this.datalistsource = new MatTableDataSource(allresults.results);
      this.datalistsource.sort = this.sort;
      this.datalistsource.paginator = this.paginator;

      this.closeConfirmRemoveDialog();
    });


  }

  getAdminentityurl() {
    return this.entityroot;
  } // getAdminentitylink

  getEditLink(entityid: string = '') {
    return [this.entityroot + '/' + entityid + '/edit'];
  } // getEditLink

  getDetailsLink(entityid: string = '') {
    return [this.entityroot + '/' + entityid];
  }

  getEditUrl(entityid: string = '') {
    return this.entityroot + '/' + entityid + '/edit';
  } // getEditUrl

  getCreateLink() {
    return [this.entityroot + '/create'];
  } // getCreateLink

  getUserListLink(entityid: string = '') {
    return [window.location.pathname + '/' + entityid + '/users'];
  } // getUserListLink



}
